import type { TExposedFacilityDTO } from '@doutorsim/shared/facilities'
import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface FacilityState {
  currentFacility: TExposedFacilityDTO | null
  availableFacilities: TExposedFacilityDTO[]
  setCurrentFacility: (facility: TExposedFacilityDTO) => void
  setAvailableFacilities: (facilities: TExposedFacilityDTO[]) => void
  switchFacility: (facilityId: string) => void
  clear: () => void
}

export const useFacilityStore = create<FacilityState>()(
  persist(
    (set, get) => ({
      currentFacility: null,
      availableFacilities: [],

      setCurrentFacility: (facility) => {
        set({ currentFacility: facility })
      },

      setAvailableFacilities: (facilities) => {
        set({ availableFacilities: facilities })
      },

      switchFacility: (facilityId) => {
        const facility = get().availableFacilities.find((f) => f.id === facilityId)
        if (facility) {
          set({ currentFacility: facility })
        }
      },

      clear: () => {
        set({
          currentFacility: null,
          availableFacilities: [],
        })
      },
    }),
    {
      name: 'facility-storage',
    },
  ),
)
